<template>
  <div>
    <base-checkbox v-model="isSelected" class="mt-3 mr-3 float-left d-inline-block" />

    <p @click="isSelected = !isSelected" class="cursor-pointer">
      <span class="font-weight-bold">{{ name }}</span>
      <small class="text-muted d-block">{{ description }}</small>
    </p>
  </div>
</template>

<script>
import BaseCheckbox from "@/components/Forms/Base/BaseCheckbox";

export default {
  name: "Focus",
  components: { BaseCheckbox },
  props: {
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isSelected: false,
  }),
  watch: {
    isSelected(value) {
      const { id } = this;
      this.$emit("handle-resources", { id, value });
    },
  },
};
</script>
